export enum PartePolo {
  ATIVO = 'ATIVO',
  PASSIVO = 'PASSIVO',
  TERCEIRO = 'TERCEIRO',
  FISCAL_LEI = 'FISCAL_LEI',
  TESTEMUNHA_JUIZO = 'TESTEMUNHA_JUIZO',
  ASSISTENTE_DESINTERESSADO_AMICUS_CURAE = 'ASSISTENTE_DESINTERESSADO_AMICUS_CURAE',
  VITIMA = 'VITIMA',
  OUTROS_PARTICIPANTES = 'OUTROS_PARTICIPANTES',
  NAO_VINCULADOS = 'NAO_VINCULADOS',
}
